// extracted by mini-css-extract-plugin
export default {"powerBy":"power-by_powerBy__hsQSo","invert":"power-by_invert__2ONFg"};